import React from 'react';

function Reasons({ row }) {
    const reasons = row.amendmentReasons || [];
    const ids = row.amendmentReasonIds || [];

    if (!reasons.length || ids.length !== reasons.length) {
        return null;
    }

    return (
        <>
            {reasons.map((reason, index) => (
                <li key={ids[index]}>{reason}</li>
            ))}
        </>
    );
}

export default Reasons;